import React from 'react';

/**
 * 탭 항목 설정
 * @typedef {Object} TabItem
 * @property {string} key - 탭 식별자
 * @property {string} label - 탭에 표시할 텍스트
 */

/**
 * 탭 바 공통 컴포넌트 (페이지별 탭 구성 가능)
 * @param {Object} props
 * @param {TabItem[]} props.items - 탭 목록 ({ key, label })
 * @param {string} props.activeKey - 현재 선택된 탭의 key
 * @param {function(string): void} props.onTabChange - 탭 클릭 시 콜백 (key 전달)
 * @param {string} [props.className] - 컨테이너 추가 클래스
 * @param {string} [props.activeClassName] - 선택 탭 버튼 클래스 (기본: primary 색 + 하단 보더)
 * @param {string} [props.inactiveClassName] - 비선택 탭 버튼 클래스 (기본: 회색 텍스트)
 */
function TabBar(props) {
  const {
    items = [],
    activeKey,
    onTabChange,
    className = '',
    activeClassName = 'text-[#135bec] border-b-2 border-[#135bec] py-3 text-sm font-bold',
    inactiveClassName = 'py-3 text-sm font-medium text-slate-500',
  } = props;

  if (items.length === 0) return null;

  return (
    <div
      className={`flex-shrink-0 border-b border-slate-100 bg-white ${className}`.trim()}
    >
      <div className="hide-scrollbar overflow-x-auto overscroll-x-contain [-webkit-overflow-scrolling:touch]">
        <div className="flex min-w-max gap-6 px-4">
          {items.map((tab) => {
            const isActive = activeKey === tab.key;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => onTabChange(tab.key)}
                className={`shrink-0 whitespace-nowrap ${
                  isActive ? activeClassName : inactiveClassName
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default TabBar;
